import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService} from './main.service';

@Injectable()
export class AddressService {

  constructor(public http: Http, public mainService: MainService) { }

  findAll() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"address")
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  create(address:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"address",address)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  edit(address:any){
    let promise = new Promise((resolve, reject) => {
      this.http.put(this.mainService.server_url+"address/"+address.idAddress,address)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  remove(id:number){
    let promise = new Promise((resolve, reject) => {
      this.http.delete(this.mainService.server_url+"address/"+id)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  findAddressByCoordinates(position:any){
    let request = {latitude:position.latitude,longitude:position.longitude,idDevice:position.idDevice,deviceTime:position.deviceTime};
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"address/findAddressByCoordinates",request)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/address.service.ts